import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { infoTextCategoria } from '../../actions/configFormularioAction';

// ── Iconos ───────────────────────────────────────────────────────────────────
const IconHistorial   = () => <svg xmlns="http://www.w3.org/2000/svg" style={{width:18,height:18,flexShrink:0}} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /></svg>;
const IconUsuarios    = () => <svg xmlns="http://www.w3.org/2000/svg" style={{width:18,height:18,flexShrink:0}} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>;
const IconMunicipios  = () => <svg xmlns="http://www.w3.org/2000/svg" style={{width:18,height:18,flexShrink:0}} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21" /></svg>;
const IconTextos      = () => <svg xmlns="http://www.w3.org/2000/svg" style={{width:18,height:18,flexShrink:0}} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>;
const IconConstantes  = () => <svg xmlns="http://www.w3.org/2000/svg" style={{width:18,height:18,flexShrink:0}} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg>;
const IconIndicadores = () => <svg xmlns="http://www.w3.org/2000/svg" style={{width:18,height:18,flexShrink:0}} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" /></svg>;
const IconPDF         = () => <svg xmlns="http://www.w3.org/2000/svg" style={{width:18,height:18,flexShrink:0}} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" /><path strokeLinecap="round" strokeLinejoin="round" d="M9 13h6m-3-3v6" /></svg>;

const GRUPOS = [
    { label: 'Panel',      items: [{ id:'historial',   label:'Historial',   Icon:IconHistorial   }] },
    { label: 'Gestión',    items: [{ id:'usuarios',    label:'Usuarios',    Icon:IconUsuarios    },
                                   { id:'municipios',  label:'Municipios',  Icon:IconMunicipios  }] },
    { label: 'Formulario', items: [{ id:'textos',      label:'Textos',      Icon:IconTextos      },
                                   { id:'constantes',  label:'Constantes',  Icon:IconConstantes  },
                                   { id:'indicadores', label:'Indicadores', Icon:IconIndicadores },
                                   { id:'pdf',         label:'PDF',         Icon:IconPDF         }] },
];

const VISTAS_EVALUACION = ['textos', 'constantes', 'indicadores', 'pdf'];

export const AdminLayout = ({ children, vista, onCambiarVista }) => {
    const dispatch  = useDispatch();
    const navegacio = useNavigate();
    const location  = useLocation();
    const { auth, configUsuari } = useSelector(state => state);

    const nombreAdmin = configUsuari?.contingut
        ? `${configUsuari.contingut.nombre} ${configUsuari.contingut.apellido}`
        : 'Administrador';

    const enEvaluacion = location.pathname === '/evaluacion';
    const enMenu       = location.pathname === '/' || location.pathname === '/menu';

    const handleNavItem = (item) => {
        if (VISTAS_EVALUACION.includes(item.id)) {
            if (item.id === 'textos') dispatch(infoTextCategoria(auth.tokenJwt));
            onCambiarVista(item.id);
            if (!enEvaluacion) navegacio('/evaluacion');
        } else {
            onCambiarVista(item.id);
            if (!enMenu) navegacio('/');
        }
    };

    return (
        <div className="al-layout">

            {/* ── SIDEBAR ── */}
            <aside className="al-sidebar">

                {/* Avatar */}
                <div className="al-sidebar-avatar-wrap">
                    <div className="al-avatar-circle">
                        {nombreAdmin.charAt(0).toUpperCase()}
                    </div>
                    <div className="al-avatar-info">
                        <p className="al-avatar-name">{nombreAdmin}</p>
                        <span className="al-avatar-badge">Admin</span>
                    </div>
                </div>

                {/* Navegación */}
                <nav className="al-sidebar-nav">
                    {GRUPOS.map((grupo, gi) => (
                        <div key={gi}>
                            <p className="al-nav-group-label">{grupo.label}</p>
                            {grupo.items.map(item => (
                                <NavBtn key={item.id} item={item} active={vista === item.id} onClick={handleNavItem} />
                            ))}
                        </div>
                    ))}
                </nav>

                {/* Footer */}
                <div className="al-sidebar-footer">
                    Ciudad que Cuida · Admin
                </div>
            </aside>

            {/* ── CONTENIDO ── */}
            <div className="al-main" style={{ padding:'32px 40px' }}>
                {children}
            </div>
        </div>
    );
};

const NavBtn = ({ item, active, onClick }) => (
    <button
        onClick={() => onClick(item)}
        className={`al-nav-btn${active ? ' active' : ''}`}
    >
        <item.Icon />{item.label}
    </button>
);